import React from 'react'
import FundIcon from 'assets/images/funds/moneypool-2.png'
import Fund2Icon from 'assets/images/funds/moneyPool-1.svg'
import { ConvertJalaliDate } from 'utilities/helper/digitToMonth'
import EditIcon from 'assets/images/loans/edit.svg'
import { useNavigate, useParams } from 'react-router-dom'
interface IHeaderProps {
    imageId: number
    avatar: string | null
    name: string
    date: string
    shareValueAmount: number
}

export default function SettingHeader({
    imageId,
    avatar,
    name,
    date,
    shareValueAmount,
}: IHeaderProps) {
    const { id } = useParams()
    const navigate = useNavigate()
    return (
        <>
            <div className=" flex items-center my-3">
                <img
                    src={avatar ? avatar : imageId === 2 ? FundIcon : Fund2Icon}
                    alt="fund"
                    className=" w-20 h-20 rounded-full mr-2"
                    onError={(e) => {
                        e.currentTarget.onerror = null
                        e.currentTarget.src =
                            imageId === 2 ? FundIcon : Fund2Icon
                    }}
                />
                <div className="w-full mx-2">
                    <p className=" mb-3">{name}</p>
                    <p className=" text-sm text-gray-4">
                        تاریخ سررسید: {ConvertJalaliDate(date)}
                    </p>
                    <div className=" flex justify-between items-center my-2">
                        <p className=" text-sm text-gray-4">
                            حق عضویت:{' '}
                            {shareValueAmount &&
                                shareValueAmount.toLocaleString()}
                        </p>
                        <img
                            src={EditIcon}
                            alt="edit"
                            className=" w-4 h-4"
                            onClick={() => navigate(`/fund/setting/info/${id}`)}
                        />
                    </div>
                </div>
            </div>
            <hr className=" w-full" />
        </>
    )
}
